import { Avatar, Box, Divider, Text } from "@wix/design-system";
import { useAppContext } from "../Common/useAppContext";

export const ProfileDetails = () => {
  const { userDetails } = useAppContext();
  return (
    <>
      <Box align="left" width="100%" gap={2}>
        <Box marginTop={1}>
          <Avatar imgProps={{ src: userDetails?.profileImage }} size="size30" />
        </Box>
        <Box direction="vertical">
          <Text size="medium">{userDetails?.fullName}</Text>
          <Text size="small" light secondary>
            {userDetails?.email}
          </Text>
        </Box>
      </Box>
      <Divider />
    </>
  );
};
